module.exports = __webpack_public_path__ + "img/log.0df79171.png";